import { useToast } from "hooks/useToast";
import { useAddS174BenefitEntryMutation } from "store/apis/estimatedTax";
import { BackendError } from "types/utils/error";
import { S174EntryFormModal, S174Form } from "./S174EntryFormModal";

type Props = {
  open: boolean;
  onClose: () => void;
  entityId: string;
};

const INITIAL_VALUES: S174Form = { period_year: "", amount: "" };

export const AddS174BenefitEntryModal = ({
  open,
  onClose,
  entityId,
}: Props) => {
  const { alertToast, successToast } = useToast();
  const [addEntry, { isLoading }] = useAddS174BenefitEntryMutation();

  const handleSubmit = async (values: S174Form) => {
    try {
      await addEntry({
        entityId,
        payload: {
          period_year: Number(values.period_year),
          amount: Number(values.amount),
        },
      }).unwrap();
      successToast({ message: "R&D expense entry added" });
      onClose();
    } catch (e) {
      alertToast({
        message:
          (e as BackendError)?.data?.error?.message ||
          "Failed to save R&D expense entry",
      });
    }
  };

  return (
    <S174EntryFormModal
      open={open}
      onClose={onClose}
      initialValues={INITIAL_VALUES}
      title="Add R&D expense entry"
      submitLabel="Add entry"
      isLoading={isLoading}
      onSubmit={handleSubmit}
    />
  );
};
